module.exports = __webpack_public_path__ + "static/media/use12.dfa0e216.jpeg";